import { i18nSaga } from './i18n.saga';
import { all } from 'redux-saga/effects';
import { pagesSaga } from './pages.saga';
import { templatesSaga } from './templates.saga';
import { singlePageSaga } from './singlePage.saga';
import { settingsSaga } from './settings.saga';
import { searchSaga } from './search.saga';

export function* rootSaga() {
    yield all([i18nSaga(), pagesSaga(), singlePageSaga(), templatesSaga(), settingsSaga(), searchSaga()]);
}
